import request from '@/utils/request'

// 获取数据总览统计信息
export function getOverviewStatistics() {
  return request({
    url: '/home/home/count',
    method: 'get'
  })
}

// 获取近7天图表数据
export function getChartData() {
  return request({
    url: '/home/home/chart',
    method: 'get'
  })
}
